import { z } from "zod";

export const MarketplaceCartShipmentDataSchema = z.object({
  AccountName: z.string().optional(),
  Weight: z.number().optional(),
  CountryCode: z.string().optional(),
  PostalCode: z.string().optional(),
});

export type MarketplaceCartShipmentDataType = z.infer<
  typeof MarketplaceCartShipmentDataSchema
>;

export const MarketplaceCartShipmentItemSchema = z.object({
  Name: z.string().optional(),
  Code: z.string().optional(),
  ShippingMethodCode: z.number().optional(),
  Result: z
    .object({
      Cost: z.number().optional(),
      Days: z.number().optional(),
    })
    .optional(),
});

export type MarketplaceCartShipmentItemType = z.infer<
  typeof MarketplaceCartShipmentItemSchema
>;
